import { render } from "./MediaPlayer.vue?vue&type=template&id=029d3f65&scoped=true"
import script from "./MediaPlayer.vue?vue&type=script&lang=js"
export * from "./MediaPlayer.vue?vue&type=script&lang=js"

import "./MediaPlayer.vue?vue&type=style&index=0&id=029d3f65&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029d3f65"],['__file',"src/components/MediaPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "029d3f65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('029d3f65', __exports__)) {
    api.reload('029d3f65', __exports__)
  }
  
  module.hot.accept("./MediaPlayer.vue?vue&type=template&id=029d3f65&scoped=true", () => {
    api.rerender('029d3f65', render)
  })

}


export default __exports__